import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-0.75 -0.75 24 24"
        id="Dollar-Increase--Streamline-Flex.svg"
        height="24"
        width="24"
    >
        <desc>Dollar Increase Streamline Icon: https://streamlinehq.com</desc>
        <g id="dollar-increase--dollar-increase-arrow-up-fluctuate-investment">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.5638375 5.132973214285713v-0.8569446428571427"
                strokeWidth="1.5"
            ></path>
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.5638375 12.83649107142857v-0.8527660714285714"
                strokeWidth="1.5"
            ></path>
            <path
                id="Vector 3176"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.803985714285714 6.75721607142857c0 -0.8794767857142857 -0.7219767857142857 -1.6266053571428571 -2.240132142857143 -1.6266053571428571 -1.518155357142857 0 -2.240148214285714 0.7036714285714285 -2.240148214285714 1.6266053571428571 0 0.7192285714285713 0.721992857142857 1.409705357142857 2.240148214285714 1.6265892857142856 1.518155357142857 0.21688392857142852 2.582566071428571 0.7174124999999999 2.582566071428571 1.8012374999999998 0 0.9753910714285713 -1.0644107142857142 1.7943910714285711 -2.582566071428571 1.7943910714285711s-2.5825821428571425 -0.6973553571428571 -2.5825821428571425 -1.6265892857142856"
                strokeWidth="1.5"
            ></path>
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.07817857142857 10.847314285714285c0.1515535714285714 -0.7021124999999999 0.22869642857142858 -1.4670964285714285 0.22869642857142858 -2.2921071428571427C16.306874999999998 3.594166071428571 13.516264285714284 0.8035714285714285 8.555207142857142 0.8035714285714285 3.594166071428571 0.8035714285714285 0.8035714285714285 3.594166071428571 0.8035714285714285 8.555207142857142c0 3.7544625 1.5982553571428568 6.265848214285714 4.525955357142856 7.265362499999999"
                strokeWidth="1.5"
            ></path>
            <path
                id="Vector 3175"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.51725357142857 21.69642857142857s3.790703571428571 -5.010107142857143 5.471614285714285 -4.873660714285714c1.350305357142857 0.10960714285714285 1.4707767857142855 2.9806071428571426 2.7225964285714284 2.4626249999999996 0.8361160714285714 -0.3460178571428571 5.59880357142857 -4.667351785714285 6.771535714285713 -5.73774107142857"
                strokeWidth="1.5"
            ></path>
            <path
                id="Vector_4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.476874999999996 13.189001785714286c1.2464999999999997 -0.3109982142857142 2.866660714285714 -0.18559285714285711 4.050482142857143 0.31347321428571423 0.3109821428571428 1.2465321428571428 0.18562499999999998 2.866757142857143 -0.3135535714285714 4.050578571428571"
                strokeWidth="1.5"
            ></path>
        </g>
    </svg>,
) as React.FC;
